import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function RecuperarSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) { toast.error("Informe um e-mail válido"); return; }
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o e-mail existir, enviaremos um link de acesso.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mc-container py-20 flex justify-center" data-testid="page-recuperar">
      <div className="mc-card w-full max-w-md p-8 mc-fade-up">
        <h1 className="text-3xl font-bold text-center text-[#1e1b2e]">Recuperar a senha</h1>
        <p className="text-center text-muted-foreground mt-2 text-sm">Enviaremos um link por e-mail que permitirá o login instantâneo</p>
        <form onSubmit={submit} className="mt-6 space-y-4" noValidate>
          <div>
            <label className="block text-sm font-semibold text-[#1e1b2e] mb-2">Endereço de e-mail</label>
            <input className="mc-input" data-testid="recover-email" placeholder="Digite seu nome ou e-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <button className="btn-primary w-full" data-testid="recover-submit" disabled={loading || sent}>{sent ? "E-mail enviado" : loading ? "Enviando..." : "Enviar e-mail"}</button>
        </form>
      </div>
    </div>
  );
}
